<div
  layout="row"
  layout-margin
  layout-wrap
>
  <div
    flex="30"
    flex-sm="100"
  >
    <form
      [formGroup]="formSettings"
      (submit)="submitTotemSettingsForm()"
      method="post"
    >
      <div style="margin: 40px">
        <h2 class="title">Totem</h2>
        <div class="ui grid">
          <div class="eight wide computer sixteen wide mobile column">
            <div class="card">
              <div class="form-column">
                <mat-form-field>
                  <mat-label>Opção de atendimento prioritário</mat-label>
                  <mat-select
                    (selectionChange)="prioritaryChange()"
                    required
                    style="height: 10px !important"
                    formControlName="PRIORITY"
                  >
                    <mat-option value="true">Sim</mat-option>
                    <mat-option value="false">Não</mat-option>
                  </mat-select>
                </mat-form-field>
                <img
                  class="rounded"
                  [src]="prioritarySrc"
                />
              </div>
            </div>
          </div>
          <div class="eight wide computer sixteen wide mobile column">
            <div class="card">
              <div class="form-column">
                <mat-form-field>
                  <mat-label>Data de Nascimento, buscar por</mat-label>
                  <mat-select
                    (selectionChange)="birthdateChange()"
                    required
                    style="height: 10px !important"
                    formControlName="TOTEM_CALENDAR"
                  >
                    <mat-option value="both">Ambos</mat-option>
                    <mat-option value="calendar">Calendário</mat-option>
                    <mat-option value="input">Input</mat-option>
                  </mat-select>
                </mat-form-field>
                <img
                  class="rounded"
                  [src]="birthdateSrc"
                />
              </div>
            </div>
          </div>
          <div class="sixteen wide column">
            <div class="card">
              <div class="ui grid">
                <div class="eight wide column">
                  <h3 class="setting-title">Impressão</h3>
                  <div class="form-inputs-row">
                    <mat-form-field>
                      <mat-label>Impressão térmica</mat-label>
                      <mat-select
                        required
                        style="height: 10px !important"
                        formControlName="TOTEM_PRINTER"
                      >
                        <mat-option value="true">Sim</mat-option>
                        <mat-option value="false">Não</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button
                      (click)="testPrint()"
                      mat-button
                      color="primary"
                      type="button"
                    >
                      Teste local
                    </button>
                  </div>
                </div>
                <div class="eight wide column">
                  <h3 class="setting-title">
                    Modificar status do agendamento pós check-in no totem
                  </h3>
                  <div class="form-inputs-row">
                    <mat-form-field>
                      <mat-label>Modificar status</mat-label>
                      <mat-select
                        required
                        style="height: 10px !important"
                        formControlName="TOTEM_CHECKIN_CHANGES_STATUS"
                      >
                        <mat-option value="true">Sim</mat-option>
                        <mat-option value="false">Não</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="eight wide column">
                  <h3 class="setting-title">Dados do paciente</h3>
                  <div class="form-inputs-row">
                    <mat-form-field>
                      <mat-label>Pular atualização de cadastro do paciente</mat-label>
                      <mat-select
                        required
                        style="height: 10px !important"
                        formControlName="TOTEM_SKIP_PATIENT_DATA"
                      >
                        <mat-option value="true">Sim</mat-option>
                        <mat-option value="false">Não</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <h3 class="setting-title">Mensagem após Check-in</h3>
              <div class="form-inputs-row">
                <ckeditor
                  [config]="{ versionCheck: false }"
                  style="width: 100%"
                  data="<p>Hello, world!</p>"
                  formControlName="MESSAGE_AFTER_CHECKIN"
                >
                </ckeditor>
              </div>
            </div>

            <div
              class="card"
              *ngIf="appearanceEnabled === 'true'"
            >
              <h3 class="setting-title">Aparência</h3>
              <div class="form-inputs-row">
                <mat-form-field style="width: 100%">
                  <mat-label>Tipo</mat-label>
                  <mat-select
                    required
                    style="height: 10px !important; padding-top: 14px"
                    formControlName="TOTEM_BACKGROUND_TYPE"
                  >
                    <mat-option value="color">Cor</mat-option>
                    <mat-option value="gradient">Degradê</mat-option>
                    <mat-option value="image">Imagem</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  *ngIf="
                    formSettings.get('TOTEM_BACKGROUND_TYPE')?.value === 'color' ||
                    formSettings.get('TOTEM_BACKGROUND_TYPE')?.value === 'gradient'
                  "
                  style="width: 100%"
                >
                  <div style="display: flex; align-items: center">
                    <input
                      matInput
                      type="color"
                      class="color-input"
                      style="width: 30px; height: 30px; padding: 0; margin-right: 4px"
                      formControlName="TOTEM_BACKGROUND_COLOR_PRIMARY"
                      (input)="onColorChange($event, 'TOTEM_BACKGROUND_COLOR_PRIMARY')"
                    />
                    <input
                      matInput
                      type="text"
                      style="flex: 1"
                      formControlName="TOTEM_BACKGROUND_COLOR_PRIMARY"
                      (input)="onColorChange($event, 'TOTEM_BACKGROUND_COLOR_PRIMARY')"
                    />
                  </div>
                  <mat-label>Cor de fundo primária</mat-label>
                </mat-form-field>
                <mat-form-field
                  *ngIf="formSettings.get('TOTEM_BACKGROUND_TYPE')?.value === 'gradient'"
                  style="width: 100%"
                >
                  <div style="display: flex; align-items: center">
                    <input
                      matInput
                      type="color"
                      class="color-input"
                      style="width: 30px; height: 30px; padding: 0; margin-right: 4px"
                      formControlName="TOTEM_BACKGROUND_COLOR_SECONDARY"
                      (input)="onColorChange($event, 'TOTEM_BACKGROUND_COLOR_SECONDARY')"
                    />
                    <input
                      matInput
                      type="text"
                      style="flex: 1"
                      formControlName="TOTEM_BACKGROUND_COLOR_SECONDARY"
                      (input)="onColorChange($event, 'TOTEM_BACKGROUND_COLOR_SECONDARY')"
                    />
                  </div>
                  <mat-label>Cor de fundo secundária</mat-label>
                </mat-form-field>
                <mat-form-field>
                  <div style="display: flex; align-items: center">
                    <input
                      matInput
                      type="color"
                      class="color-input"
                      style="width: 30px; height: 30px; padding: 0; margin-right: 4px"
                      formControlName="TEXT_COLOR"
                      (input)="onColorChange($event, 'TEXT_COLOR')"
                    />
                    <input
                      matInput
                      type="text"
                      style="flex: 1"
                      formControlName="TEXT_COLOR"
                      (input)="onColorChange($event, 'TEXT_COLOR')"
                    />
                  </div>
                  <mat-label>Cor do texto</mat-label>
                </mat-form-field>
                <mat-form-field
                  *ngIf="formSettings.get('TOTEM_BACKGROUND_TYPE')?.value === 'image'"
                  style="width: 100%"
                >
                  <mat-label>Imagem de Fundo</mat-label>
                  <button
                    type="button"
                    mat-icon-button
                    matPrefix
                    (click)="f_input.click()"
                  >
                    <mat-icon>attach_file</mat-icon>
                  </button>
                  <input
                    type="text"
                    style="padding-top: 14px"
                    readonly
                    matInput
                    formControlName="TOTEM_BACKGROUND_IMAGE_NAME"
                  />
                  <input
                    type="file"
                    hidden
                    #f_input
                    (change)="handleFileInputChange(f_input.files)"
                  />
                </mat-form-field>
              </div>
              <div class="form-inputs-row">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  style="background-color: #d1d5db; color: #353535"
                  (click)="restoreAppearance()"
                >
                  Restaurar Aparência
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-8 mx-auto mt-5">
        <div style="margin: 40px">
          <button
            [disabled]="showSpinner ? true : false"
            class="mt-3"
            type="submit"
            mat-raised-button
            color="primary"
          >
            <mat-spinner
              diameter="18"
              [style.display]="showSpinner ? 'inline-block' : 'none'"
            >
            </mat-spinner
            >Salvar Alterações
          </button>
        </div>
      </div>
    </form>
    <app-settings-setores></app-settings-setores>
    <app-add-totem></app-add-totem>
  </div>
</div>
